<template>
  <!-- delete files / folders dialog -->
  <qc-dialog class="tc-15-rich-dialog cos" :show="innerShow" type="prompt"
    :text-title="$t('cos.confirm.clear_bucket[0]')" :default-cancel="false" icon="error" :width="500"
    @close="closeDialog">
    <ul class="form-list form-list-vertical">
      <li class="pure-text-row">
        <div class="form-label custom-label">
          <label>{{$t('cos.confirm.clear_bucket[1]')}}</label>
        </div>
      </li>
      <li>
        <div class="form-label allow-user-select">{{$t('cos.confirm.clear_bucket[2]')}} <span
            class="text-strong">{{bucketInfo.Bucket}}</span> {{$t('cos.confirm.clear_bucket[3]')}}</div>
        <div class="form-input mt-10">
          <div class="form-unit" :class="{'is-error': errMsg}">
            <qc-input size="large" :placeholder="$t('cos.confirm.clear_bucket[2]')" v-model.trim="bucketName">
            </qc-input>
            <template v-if="errMsg">
              <qc-icon class="ml-5" type="error"></qc-icon>
              <div class="tc-15-input-tips form-input-help">{{errMsg}}</div>
            </template>
          </div>
        </div>
      </li>

    </ul>

    <div slot="button">
      <div class="justify-grid">
        <div class="col"></div>
        <div class="col">
          <qc-button type="default" @click="checkBucket" :title="$t('core.ok')" :disabled="disabledBtn">
            {{$t('core.ok')}}
          </qc-button>
          <qc-button type="weak" @click="closeDialog" :title="$t('core.cancel')">{{$t('core.cancel')}}
          </qc-button>
        </div>
      </div>
    </div>

  </qc-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    bucketInfo: Object,
  },
  data() {
    return {
      bucketName: '',
      errBucket: false,
      errMsg: '',
    };
  },
  computed: {
    innerShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      },
    },
    disabledBtn() {
      return !this.bucketName;
    },
  },
  methods: {
    initData() {
      this.bucketName = '';
      this.errBucket = false;
      this.errMsg = '';
    },
    checkBucket() {
      if (this.bucketInfo.Bucket !== this.bucketName) {
        this.errMsg = window.lang.t('error.bucketNameError');
        return;
      }
      this.errMsg = '';
      this.Confirm();
    },
    Confirm() {
      this.$emit('confirm');
      this.closeDialog();
    },
    closeDialog() {
      this.initData();
      this.innerShow = false;
    },
  },
};
</script>

<style scoped lang="scss">
.custom-label {
  ::v-deep label {
    white-space: unset;
    line-height: 22px;
  }
}
</style>
